import { Component } from '@angular/core';
import { Platform, AlertController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { pushNotiService } from './pages/operacion/services/pushNotifications.service';
import { ScreenOrientation } from '@ionic-native/screen-orientation/ngx';
import { SwUpdate } from '@angular/service-worker';
import { WebPushNotificationService } from './pages/operacion/services/webPushNotification.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  showSplash = true;
  constructor(
    private platform: Platform,
    private swUpdate: SwUpdate,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private pushService:pushNotiService,
    private screenOrientation: ScreenOrientation,
    public alertController: AlertController,
    private messagingService:WebPushNotificationService,
  ) {
    this.initializeApp();
    this.messagingService.tokenWebPushNotify();
    // console.log(this.screenOrientation.type)
  }

  initializeApp() {
    if(this.swUpdate.isEnabled){
      this.swUpdate.available.subscribe(()=>{
        this.presentAlert('Nueva Actualización','Disfruta de la nueva versión');
      })
    }

    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      if(this.platform.is('cordova')){
        this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.PORTRAIT);
        this.pushService.config();
      }
    });
  }


  async presentAlert(titulo, mensaje, subtitle?, ) {
    const alert = await this.alertController.create({
      header: titulo,
      subHeader: subtitle,
      message: mensaje,
      buttons: [
        {
          text: 'OK ',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            window.location.reload();
            // console.log('Confirm Cancel');
          }
        }
      ]
    });
    await alert.present();
  }
}

